var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"fill-height overflow-hidden"},[_c('vue-headful',{attrs:{"title":_vm.pageTitle}}),_vm._v(" "),_c('embed',{staticClass:"embed",attrs:{"src":_vm.$route.query.link,"type":"application/pdf"}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7e0e9f07","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/pdf/View.vue
// module id = null
// module chunks = 